import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import axios from 'axios';
import { getToken } from '../firebase';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    const handlePaymentCancel = async () => {
      try {
        // if (!sessionId) {
        //   throw new Error('No session ID found');
        // }

        const response = await axios.post(
          `${location.protocol}//${location.hostname}/api/server/payment-cancel`,
          {
            headers: {
              'Authorization': `Bearer ${await getToken()}`
            }
          }
        );

        if (response.data.success) {
          // Redirect back to admin page after 5 seconds
          setTimeout(() => {
            navigate('/admin');
          }, 5000);
        } else {
          throw new Error('Failed to process cancellation');
        }
      } catch (err) {
        console.error('Error processing payment cancellation:', err);
        setError(err.message);
      }
    };

    handlePaymentCancel();
  }, [sessionId, navigate]);

  if (error) {
    return (
      <div className="min-h-full h-full flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="max-w-md w-full space-y-8 p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
          <div className="text-center">
            <div className="text-red-500 text-2xl mb-4">⚠️</div>
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
              Error Processing Cancellation
            </h2>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
              {error}
            </p>
            <button
              onClick={() => navigate('/admin')}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Return to Admin Page
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-full h-full flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full space-y-8 p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
        <div className="text-center">
          <div className="text-yellow-500 text-2xl mb-4">⚠️</div>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
            Payment Cancelled
          </h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Your payment has been cancelled. You will be redirected back to the admin page in 5 seconds.
          </p>
          <button
            onClick={() => navigate('/admin')}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Return to Admin Page Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel; 
